export class NomenclatureListFilter {

  constructor() { }

  name: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/models/nomenclature-list-filter.ts